<template>
  <b-container>
    <b-row v-for="row in items" :key="row.customFieldId">
      <!-- {{row}} -->
      <b-col v-if="row.active == true && row.fieldName != null">
        <b-form-group :label="row.fieldName" label-for="fieldName">
          <b-form-textarea
            v-if="row.customField == 1"
            id="fieldName"
            v-model="row.value"
            :placeholder="row.tip"
            :readonly="readonly"
          />
          <b-form-input
            v-if="row.customField == 0"
            id="fieldName"
            v-model="row.value"
            :placeholder="row.tip"
            :readonly="readonly"
          />
          <!-- lista de modelstate -->
          <div
            class="text-danger"
            v-if="hasErros && row.required && row.value == null"
          >
            {{ "Campo obrigátorio" }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- <div>{{ items }}</div> -->
    <!-- <div>{{model}}</div> -->
    <!-- <div>{{customValue}}</div> -->
    <!-- <div>Id: {{ occurrenceId }}</div> -->
    <!-- <div>{{modelstate}}</div> -->
  </b-container>
</template>
<script>
import CustomFields from "@/components_rms/trackingShippingCompany/cargoExpense/CustomFields.vue";
export default {
  name: "CustomValue",
  props: {
    items: Array,
    occurrenceId: Number,
    id: String,
    readonly: Boolean,
    modelstate: Object,
  },
  data() {
    return {
      model: [],
      editField: false
    };
  },
  created() {
  },
  components: {
    CustomFields,
  },
  computed: {
    hasErros() {
      if (!this.modelstate) return false;
      if (this.modelstate.length == 0) return false;

      let count = 0;
      for (let variable in this.modelstate) {
        count++;
      }
      if (count == 0) return false;

      return true;
    },
  },
  mounted() {
    this.model = this.items;
    if (this.occurrenceId != 0) this.getCustomValue();
  },
  methods: {    
    getCustomValue() {
      this.$api
        .get(
          "v1/cargoExpenseCustomField/getAllValues/" +
            this.occurrenceId +
            "/" +
            this.id
        )
        .then((response) => {
          let item = response.data;
          this.model = item;
          this.$emit("update:items", item);
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },    
  },
  watch: {
    occurrenceId() {
      if (this.occurrenceId != 0) {
        this.getCustomValue();
        this.$forceUpdate();
      }
    },
    model(){
      let value = this.model;
      console.log("values");
      console.log(value);
      if (value == "") value = null;
      this.$emit("update:items", value);
    }
  },
};
</script>
<style scoped>
.btn_customField {
  margin-left: 50%;
  margin-top: -35px !important;
  width: auto;
  height: 30px;
}
.customValue {
  margin-left: 1%;
}
</style>